import type { PhoneInventory } from '../lib/selfPhoneProduct';

type Props = {
  inventory: PhoneInventory;
  loading?: boolean;
};

export default function BatchAvailabilityCounter({ inventory, loading }: Props) {
  const batch = inventory.batches?.find((b) => b.status === 'open');
  const claimedPct =
    batch && batch.size > 0 ? Math.min(100, (batch.sold / batch.size) * 100) : 0;

  return (
    <div className="rounded-xl border border-white/15 bg-white/5 px-4 py-3">
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="text-white/65">
          {loading
            ? 'Checking batch availability…'
            : inventory.soldOut
              ? 'All batches are full'
              : batch
                ? `Batch ${batch.number} · ships ${batch.shipLabel}`
                : 'Batch schedule updating…'}
        </span>
        {!loading && batch && !inventory.soldOut && (
          <span className="font-medium text-white/80">
            {batch.remaining} of {batch.size} left in this batch
          </span>
        )}
      </div>
      {!inventory.soldOut && (
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/10">
          <div
            className="h-full bg-white transition-all duration-500 ease-out"
            style={{ width: loading ? '0%' : `${claimedPct}%` }}
          />
        </div>
      )}
      {!loading && inventory.nextOrderBatch && !inventory.soldOut && (
        <p className="mt-2 text-xs text-white/45">
          New orders today join Batch {inventory.nextOrderBatch} — we&apos;ll confirm your batch
          after checkout.
        </p>
      )}
    </div>
  );
}
